import React, { useState } from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../../lib/contact";

export default function FloatingWhatsApp() {
  const [hover, setHover] = useState(false);

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escríbenos por WhatsApp"
      data-testid="floating-whatsapp"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="fixed bottom-20 right-5 sm:bottom-24 sm:right-6 z-40 flex items-center gap-3 group"
    >
      {/* Tooltip */}
      <span
        className={`hidden sm:inline-block whitespace-nowrap rounded-sm bg-brand-navy text-white font-inter text-xs px-3 py-2 shadow-[0_10px_30px_-12px_rgba(27,42,74,0.4)] transition-all duration-300 ${
          hover ? "opacity-100 -translate-x-1" : "opacity-0 translate-x-2 pointer-events-none"
        }`}
      >
        ¿Tienes dudas? Escríbenos
      </span>

      {/* Button */}
      <span className="relative flex h-14 w-14">
        <span aria-hidden className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-pulse-ring" />
        <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_14px_34px_-10px_rgba(37,211,102,0.6)] group-hover:scale-105 transition-transform duration-300">
          <MessageCircle size={26} strokeWidth={2} fill="currentColor" stroke="none" />
        </span>
      </span>
    </a>
  );
}
